import { render, staticRenderFns } from "./socialIcons.vue?vue&type=template&id=39979a5f&scoped=true&"
import script from "./socialIcons.ts?vue&type=script&lang=ts&"
export * from "./socialIcons.ts?vue&type=script&lang=ts&"
import style0 from "./socialIcons.vue?vue&type=style&index=0&id=39979a5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39979a5f",
  null
  
)

export default component.exports